import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faFolderOpen, faPlus, faTrash, faGripLines, faPencil } from "@fortawesome/free-solid-svg-icons";
import ActionMenu from "../../action-menu/ActionMenu";
import { useTranslation } from "react-i18next";
import "./FolderHeader.css";

export const FolderHeader = ({
    folder,
    listCount,
    selected = false,
    onAddList,
    onDeleteFolder,
    onToggleCollapse,
    onRenameFolder,
    showReorderHandle = false,
    showAddListAction = false,
}) => {
    const { t } = useTranslation();
    return (
        <div className={`folder-header ${selected ? 'selected' : ''}`}>
            <div className="folder-header-left" onClick={onToggleCollapse}>
                {showReorderHandle && (
                    <span className="folder-drag-handle" onClick={(e) => e.stopPropagation()}>
                        <FontAwesomeIcon icon={faGripLines} />
                    </span>
                )}
                <span className="folder-icon">
                    <FontAwesomeIcon icon={folder.collapsed ? faFolder : faFolderOpen} />
                </span>
                <span className="folder-name" title={folder.name}>
                    <span className="folder-name-text">{folder.name}</span>
                    {listCount > 0 && (
                        <span className="folder-list-count">({listCount})</span>
                    )}
                </span>
            </div>
            <div className="folder-header-actions">
                {showAddListAction && (
                    <button
                        type="button"
                        className="folder-header-add-list"
                        onClick={onAddList}
                        aria-label={t('folderMenu.addList')}
                        title={t('folderMenu.addList')}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                )}
                <ActionMenu
                    actions={[
                        {
                            label: t('folderMenu.renameFolder'),
                            icon: faPencil,
                            callback: onRenameFolder,
                        },
                        {
                            label: t('folderMenu.deleteFolder'),
                            icon: faTrash,
                            callback: onDeleteFolder,
                        },
                    ]}
                    buttonStyle={{ fontSize: 12, color: "black", background: 'transparent', padding: 4 }}
                    menuItemStyle={{ fontWeight: 400 }}
                />
            </div>
        </div>
    );
};
